import { isEmpty } from 'lib';

export const cutString = (text, num = 10) => {
  if (isEmpty(text) || text.length <= num) return text;
  return `${text.substring(0, num)} ...`;
};
